const COOKIE_SCRIPT_KEY = 'CookieScriptConsent' as const

export const getCookieConsentByCategory = (category: string): Ref<boolean> => {
  const cookie = useCookie<any>(COOKIE_SCRIPT_KEY)

  const cookieIsAllowed = computed(() => {
    if (cookie.value && cookie.value?.categories) {
      const categories = JSON.parse(cookie.value?.categories)
      return categories.includes(category)
    }
    return false
  })

  return cookieIsAllowed
}
